import { createStore, applyMiddleware, compose } from 'redux'
import { offline } from '@redux-offline/redux-offline'
import offlineConfig from '@redux-offline/redux-offline/lib/defaults'
import thunkMiddleware from 'redux-thunk'
import defaultQueue from '@redux-offline/redux-offline/lib/defaults/queue'

import rootReducer from '../reducers'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(thunkMiddleware),
    offline({
      ...offlineConfig,
      persistOptions: {
        blacklist: ['notifications', 'loading', 'error'],
      },
      retry: (_action, _retries) => null,
      queue: {
        ...defaultQueue,
        enqueue(array, action) {
          return [...array, action]
        },
      },
    }),
  ),
)
